import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getExcelDownloadApiPath } from '@/components/Dashboard/utils/getExcelDownloadURL';
import {
  isTableExcelDownloadInProgress,
  startReportsTableExcelDownload,
  subscribeTableExcelDownloadState,
} from '@/components/Dashboard/utils/reportsTableExcelDownloadManager';

export default function useAsyncTableExcelDownload(table) {
  const dispatch = useDispatch();
  const [isDownloading, setIsDownloading] = useState(() =>
    isTableExcelDownloadInProgress(table)
  );

  useEffect(
    () => subscribeTableExcelDownloadState(table, setIsDownloading),
    [table]
  );

  const handleDownloadExcel = useCallback(
    (query, tableQuery) => {
      startReportsTableExcelDownload({
        dispatch,
        table,
        downloadPath: getExcelDownloadApiPath(table, query, tableQuery),
      });
    },
    [dispatch, table]
  );

  return {
    handleDownloadExcel,
    isDownloading,
  };
}
